import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Injectable } from '@angular/core';
import { map, Observable, shareReplay } from 'rxjs';
import { CoberturaServicios, ConsultaComplementoGeneralOutput, ConsultaSiniestroOutput, Fotografia, Regla } from 'src/app/models/complementos-web/complementos-web.model';
import Swal from 'sweetalert2';
import { CoberturaProcesada } from '../../models/complementos-web/complementos-web.model';

@Injectable({ providedIn: 'root' })
export class ProcesosComunesComplementoService {

    private displayNameMap = new Map([
        [Breakpoints.XSmall, 'xs'],
        [Breakpoints.Small, 'sm'],
        [Breakpoints.Medium, 'md'],
        [Breakpoints.Large, 'lg'],
        [Breakpoints.XLarge, 'xl'],
    ]);

    public screenSize$: Observable<string>;

    constructor(private breakpointObserver: BreakpointObserver) {
        this.screenSize$ = this.breakpointObserver.observe([
            Breakpoints.XSmall,
            Breakpoints.Small,
            Breakpoints.Medium,
            Breakpoints.Large,
            Breakpoints.XLarge,
        ]).pipe(
            map(result => {
                for (const query of Object.keys(result.breakpoints)) {
                    if (result.breakpoints[query]) {
                        return this.displayNameMap.get(query) ?? 'unknown';
                    }
                }
                return 'unknown';
            }),
            shareReplay(1) // Compartir la última emisión con múltiples suscriptores
        );
    }

    alertaGeneralComplemento(title: string, text: string, icon: any, showCancelButton: boolean, showConfirmButton: boolean, html?: string, width?: string, confirmButtonText? : string) {
        return Swal.fire({
            title: title,
            text: `${text}`,
            icon: icon,
            html: html,
            showCancelButton: showCancelButton,
            showConfirmButton: showConfirmButton,
            confirmButtonText: confirmButtonText ?? 'Aceptar',
            cancelButtonText: 'Cancelar',
            confirmButtonColor: '#f99100',
            cancelButtonColor: '#ff5722',
            reverseButtons: false,
            width: width ?? '500',
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
        });
    }

    devolverSiniestro(siniestroCompleto: string) {
        const splitSiniestro = siniestroCompleto.split('-');
        return {
            moneda: splitSiniestro[0],
            ramo: splitSiniestro[1],
            sramo: splitSiniestro[2],
            oficina: splitSiniestro[3],
            consecutivo: splitSiniestro[4],
            anio: splitSiniestro[5],
            siniestroCompleto: `${siniestroCompleto}`,
        }
    }

    generarCadenaReglas(reglas: Regla[]): string {
        return reglas
            .map(item => `${item.regla}:${item.seleccionar ? 1 : 0}`)
            .join('|');
    }

    generarCadenaFotografias(fotografias: Fotografia[]): string {
        return fotografias
            .map(f => `nombre:${f.nombre}|fotografia:${f.fotografia}`)
            .join('@');
    }

    generarCadenaCoberturasServicios(coberturas: any[]): string {
        if (!coberturas || coberturas.length == 0) return '';
        return coberturas
            .map(cob => `cobertura:${cob["claveCobertura"]}|estimacion:${cob["estimacion"]}|sumaAsegurada:${cob["sumaAsegurada"]}|deducible:${cob["porcentajeDeducible"]}|conDeducible:${cob["deducible"] ? '1' : "0"}|validaCobertura:${cob["activa"] ? '1' : "0"}|descripcober:${cob["cobertura"]}`)
            .join('|');
    }
    
    generarCadenaCoberturasComplemento(importe: string,coberturas: any[], detalleCoplementoGrl : ConsultaComplementoGeneralOutput, consultaSiniestro : ConsultaSiniestroOutput): string {
        const tipoPerdida = consultaSiniestro?.Siniestro[0].serie_normal == 1 ? consultaSiniestro?.Siniestro[0].cve_perdida_total : 0;
        if (!coberturas || coberturas.length == 0) return 'cobertura:0|estimacion:|sumaAsegurada:0|deducible:0|conDeducible:0|validaCobertura:0|descripcober:';
        const cob : CoberturaProcesada[] = coberturas.map(cob => {
            return {
                cveCobertura: cob.cve_coberturak, sumaAsegurada: cob.suma_aseg, deducible: cob.porc_deduc, importe: ((cob.estimado == null) ? ((cob.orden_servicio == 1) ? "0" : "") : cob.estimado), valida: true,
                validaImporte : consultaSiniestro.Siniestro[0].causa != 3 ? tipoPerdida == 2 && detalleCoplementoGrl["ServicioTaller"] == "0" ? true : false : false
            }
        });
        return cob
            .map(cob => {
                const importeFormated = importe?.replace(/[$,]/g, "") || "0";
                return `cobertura:${cob["cveCobertura"]}|estimacion:${importeFormated}|sumaAsegurada:${cob["sumaAsegurada"]}|deducible:${cob["deducible"]}|conDeducible:${(parseInt(importeFormated)) > 0 ? '1' : "0"}|validaCobertura:${cob["validaImporte"] ? '1' : "0"}|descripcober:`
            })
            .join(',');
    }

    generarCadenaCoberturasPagosComplemento(coberturas: CoberturaProcesada[]): string {
        if (!coberturas || coberturas.length == 0) return 'cobertura:0|estimacion:|sumaAsegurada:0|deducible:0|conDeducible:1|validaCobertura:0|descripcober:';
        return coberturas
            .map(cob => {
                const importeFormated =cob["importe"]?.replace(/[$,]/g, "") || "0";
                return `cobertura:${cob["cveCobertura"]}|estimacion:${importeFormated}|sumaAsegurada:${cob["sumaAsegurada"]}|deducible:${cob["deducible"]}|conDeducible:${cob["deducible"] ? '1' : "0"}|validaCobertura:${cob["valida"] ? '1' : "0"}|descripcober:`
            })
            .join(',');
    }
}